/** Gestes de l’assistant : erreurs traduites, rechargement versionné et garde anti-doublon. */
import { useTranslation } from 'react-i18next';
import type { AppelApi } from '../../api/client.js';
import { useActionAssistant } from '../../api/assistant-reponse.js';
import { estApiError } from '../../api/errors.js';
import { estPorteeObsolete } from '../../auth/identite.js';
import { useShellContext } from '../shell/context.js';

export function useGesteAssistant<T, V>(action: (corps: V, appel: AppelApi) => Promise<T>) {
  const { galerieSlug } = useShellContext();

  const { t } = useTranslation('regie');

  const mutation = useActionAssistant(galerieSlug, action);

  let raison = 'generique';

  if (estApiError(mutation.error)) {
    const details = mutation.error.details;
    if (
      details &&
      typeof details === 'object' &&
      'raison' in details &&
      typeof details.raison === 'string'
    )
      raison = details.raison === 'conversation_modifiee' ? 'conflit' : details.raison;
    else if (mutation.error.status === 429) raison = 'ia_debit';
    else if (mutation.error.status === 409) raison = 'conflit';
  }

  const raisons = [
    'conversation_sensible',
    'brouillon_existant',
    'ia_coupee',
    'ia_plafond',
    'ia_debit',
    'ia_indisponible',
    'ia_refus',
    'ia_invalide',
    'ia_entree_invalide',
    'conflit',
  ];

  return {
    pending: mutation.isPending,
    erreur:
      mutation.isError && !estPorteeObsolete(mutation.error)
        ? t(`assistantReponse.erreurs.${raisons.includes(raison) ? raison : 'generique'}`)
        : null,
    async executer(corps: V): Promise<T | undefined> {
      try {
        return await mutation.mutateAsync(corps);
      } catch {
        return undefined;
      }
    },
  };
}
